import { render, staticRenderFns } from "./FileSelectorWrapper.vue?vue&type=template&id=8f6a196a"
import script from "./FileSelectorWrapper.vue?vue&type=script&lang=js"
export * from "./FileSelectorWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports